<template>
    <div class="push__menu" ref="pushMenu">
            <div class="menu-wrap">
                <i class="far fa-sync-alt" @click="go('start')"></i>
                <i v-if="isWebApp" class="fas fa-cog __settings" @click="go('options')"></i>
                <ul>
                    <li menu-step="1" :class="checkCrumb(1)" @click="goBackTo(1,'size')">Size</li>
                    <li menu-step="2" :class="checkCrumb(2)" @click="goBackTo(2,'style')">Style</li>
                    <li menu-step="3" :class="checkCrumb(3)" @click="goBackTo(3,'fuel')">Fuel Type</li>
                    <li menu-step="4" :class="checkCrumb(4)" @click="goBackTo(4,'function')">Oven Function</li>
                    <li menu-step="5" :class="checkCrumb(5)" @click="goBackTo(5,'results')">Your Cooker</li>
                </ul>
                <p class="contact-no">Contact Us 0800 8046261</p>
                <div class="privacy-mobile">
                    <p><a href="http://www.rangemaster.co.uk/privacy-security" target="_blank">Privacy &amp; Security</a></p>
                </div>
            </div>
        </div>
</template>
<script>
import { isWebApp } from "../../api/index.js";
export default {
  data: function(){
    return { isWebApp: isWebApp() }
  },
  methods: {
    checkCrumb(s) {
      if (!this.$route.matched[1]) {
        return;
      }
      if (this.$route.matched[1].meta.step > s) {
        return ""; // step completed class
      }

      if (this.$route.matched[1].meta.step == s) {
        return "__active";
      }
    },
    go(name){
      this.$router.push({ name });
      setTimeout(()=>{
        document.querySelector(".push__menu").classList.remove("open"); //Hack - not enough time to fix how Dale setup the mobile menu.
      }, 50); //Hack - Delay the closing to allow routing to take place.
    },
    goBackTo(s, name) {
      if (!this.$route.matched[1].meta || this.$route.matched[1].meta.step > s) {
        this.$router.push({ name: name, params: this.$route.params });
        setTimeout(()=>{
        document.querySelector(".push__menu").classList.remove("open"); //Hack - not enough time to fix how Dale setup the mobile menu.
      }, 50); //Hack - Delay the closing to allow routing to take place.
      }
      
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ui/mobile-menu.vue